var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"body-class":"p-0","header-class":"border-0 bg-transparent"}},[_c('ve-line',{attrs:{"data":_vm.chartData,"settings":_vm.settings,"extend":_vm.extend,"toolbox":_vm.toolbox,"grid":_vm.grid,"xAxis":_vm.xAxis,"xAxisType":'time'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }